module.exports = __webpack_public_path__ + "img/mobile2.88a703dc.webp";